import React, { useState, useEffect, useRef } from 'react';
import { MenuForm } from '../Menu.js';
import { SecurityElement } from '../elements/security_element.js';
import "../../css/main.css"

import { useAPICall } from '../../hooks/useAPICall.js';
import { useLocation, useNavigate } from 'react-router-dom';
import { PageMenuElement } from '../elements/page_menu.js';
import { PRCInput } from '../controls/prcinput.js';


export function AdminFamiliesForm() {
    const location = useLocation();
    const navigate = useNavigate();

    const [pageData, setPageData] = useState();
    const [families, setFamilies] = useState([]);
    const [family, setFamily] = useState([]);
    const [members, setMembers] = useState([]);
    const { MakeCall } = useAPICall();

    let first_render = useRef(true);
    let currentFamily = useRef([]);
    const handleDataFetch = (data) => {
        setPageData(data);
        setFamilies(data.components['families']);

    }

    
    useEffect(() => {
        if (first_render.current === true) {
            MakeCall('families/getfamilies', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\"}", handleDataFetch);
    
            first_render.current = false;
        }
    
    });
    function handleNav(destination, state) {
        navigate(destination, state);
    }


    function onPageMenuClick(onclickname) {
        switch (onclickname) {
            case 'goback':
                handleNav("/Admin");
                break;
            case 'createfamily':
                if(document.getElementById("createfamilyform"))
        {
            document.getElementById("createfamilyform").style.display = "block";
        }
                break;
            default:
                break;
        }
    }



    function handleShowFamily(familyData) {
        setFamily(familyData);
        setMembers(familyData.members);
        currentFamily.current = familyData;
        if(document.getElementById("showfamilyform"))
        {
            document.getElementById("showfamilyform").style.display = "block";
        }
    }

    function ShowFamily() {
        
            return (
               
                    <div className='formbox'>
                        <div className='formtitle'>{family.family_name} - Family Members</div>
                        <div className='gridrow' key={"header"} >
                            <div className='gridcolumn' style={{ "width": "30%" }}>Num</div>
                            <div className='gridcolumn' style={{ "width": "30%" }}>Name</div>
                            <div className='gridcolumn' style={{ "width": "30%" }}>Status</div>
                        </div>
                        {members.map((member) => (
                            <div className='gridrow' key={member.membership_number}>
                                <div className='gridcell' style={{ "width": "30%" }}>{member.membership_number}</div>
                                <div className='gridcell' style={{ "width": "30%" }}>{member.forename + ' ' + member.surname}</div>
                                <div className='gridcell' style={{ "width": "30%" }}>{member.status_name}</div>
                            </div>
                        ))}
                    </div>
                  
                );
        
    }

function handleDataSave(data)
{
    if (data.components['result'].succeeded === true) {
        document.getElementById("createfamilyform").style.display ="none"
        MakeCall('families/getfamilies', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\"}", handleDataFetch, true);
        
    }
}

    function handleSaveFamily()
    {
        if(document.getElementById('createfamilyname'))
        {
            let family_name = document.getElementById('createfamilyname').value;
            MakeCall('families/savefamily', "{ \"token\" : \"" + sessionStorage.getItem("Token") + "\", " +
                                    "\"family_name\" : \"" +family_name +"\" }", handleDataSave, true);
        }
    }
    function ShowCreateFamily() {
        
            return (
                <div className='popup_form' id="createfamilyform">
                  
                    <div className='formrow' style={{"paddingBottom":"1em"}}>
                        <div className='formlabel' style={{ "width": "30%" }}>
                            Family Name
                        </div>
                        <div className='formvalue' style={{ "width": "70%" }}>
                           <PRCInput id="createfamilyname" className='logininput' style={{ "width": "100%" }}></PRCInput>
                        </div>
                    </div>                                                         
                    <div className='formrowcentered'>                    
                        <div className='formlabel'>
                            <input type='button' className='prcbtn' value='Save' onClick={handleSaveFamily}/>
                        </div>
                        <div className='formlabel'>
                            <input type='button' className='prcbtn' value='Cancel' onClick={()=>{document.getElementById("createfamilyform").style.display ="none"}}/>
                        </div>
                    </div>
                </div>);
        }
    

    return (
        <div>
            {SecurityElement(pageData)}
            {MenuForm()}
            <div className="contentdiv">
                {PageMenuElement("Manage Families", [{ "name": "Back", "onclick": "goback" },
                { "name": "Create Family", "onclick": "createfamily", "permission_name": "CreateFamily" }], onPageMenuClick)}


                <div className='formbox'>
                    <div className='formtitle'>Families</div>
                    <div className='gridrow' key={"header"} >
                        <div className='gridcolumn' style={{ "width": "50%" }}>Family</div>
                        <div className='gridcolumn' style={{ "width": "50%" }}>Active</div>


                    </div>
                    {families.map((family) => (
                        <div key={family.idpeveril_family} className='gridrow' onClick={() => { handleShowFamily(family) }}>
                            <div className='gridcell' style={{ "width": "50%" }}>{family.family_name}</div>
                            <div className='gridcell' style={{ "width": "50%" }}>{family.active_text}</div>
                        </div>
                    ))}

                </div>
                <div id='showfamilyform' style={{"display":"none"}}>
                {ShowFamily()}
                </div>

            </div>
            <div>
                {ShowCreateFamily()}
            </div>
        </div>


                    

    );
}
